import type { Installation } from "@sitescene/types";

import { useQuery } from "@tanstack/react-query";

import { installationsApi } from "@/api/installations";
import { queryKeys } from "@/api/query-keys";
import { useOrgSelection } from "@/context/use-org-selection";

/**
 * Lookout installations of the selected organization.
 *
 * The org rides along as the `X-Shadow-Org` header (see the API client); the
 * backend validates it against the caller's ShadowAccess before answering.
 * Disabled until an organization is selected, since the header would be empty.
 */
export const useInstallations = () => {
	const { selected } = useOrgSelection();
	const orgCode = selected?.orgCode ?? null;

	return useQuery({
		enabled: orgCode !== null,
		queryFn: async (): Promise<Installation[]> =>
			installationsApi.getInstallations(orgCode ?? ""),
		queryKey: queryKeys.installations(orgCode ?? ""),
	});
};
